import "../styles/Footer.css";
import {
    FaLinkedinIn,
    FaXTwitter,
    FaInstagram,
    FaFacebookF,
    FaYoutube,
    FaGoogle
} from "react-icons/fa6";
import { NavLink, useLocation } from "react-router-dom";
import SujaLogo from "../images/sujaramaha.webp";

export default function Footer() {
    const location = useLocation();

    const handleNavClick = (path) => {
        if (location.pathname === path) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    };

    return (
        <footer className="footer footer-wave" role="contentinfo">
            <div className="footer-container">

                {/* LEFT / BRAND */}
                <div className="footer-left">

                    <div className="brand-combo footer-logo-intro">
                        <div className="logo-circle ripple">
                            <img
                                src={SujaLogo}
                                alt="Sujaramaha Enterprises logo"
                                width="60"
                                height="60"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>

                        <div className="footer-brand-text">
                            <span className="footer-brand-name">Sujaramaha Enterprises</span>
                            <span className="footer-brand-tagline">A Legacy of Trust</span>
                        </div>
                    </div>

                    <h2 className="footer-heading">
                        Take the first step towards <br />
                        protection, power and technology <br />
                        you can trust
                    </h2>

                    <div className="footer-cta-btn">
                        <NavLink
                            to="/contact"
                            onClick={() => handleNavClick("/contact")}
                            className="footer-btn"
                            aria-label="Get in touch with Sujaramaha Enterprises"
                        >
                            Get In Touch →
                        </NavLink>
                    </div>

                    {/* NEWSLETTER */}
                    <p className="newsletter-note">
                        Get updates on services & offers. No spam.
                    </p>
                    <div className="footer-newsletter">
                        <input type="email" placeholder="Enter your email" />
                        <button>Subscribe</button>
                    </div>



                    {/* SOCIAL LINKS */}
                    <div className="footer-social" aria-label="Social media links">
                        <a
                            href="https://www.linkedin.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Sujaramaha Enterprises LinkedIn"
                        >
                            <FaLinkedinIn aria-hidden="true" />
                        </a>

                        <a
                            href="https://twitter.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Sujaramaha Enterprises Twitter"
                        >
                            <FaXTwitter aria-hidden="true" />
                        </a>

                        <a
                            href="https://share.google/fnzQG4UH25xKQFChg"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Sujaramaha Enterprises Google profile"
                        >
                            <FaGoogle aria-hidden="true" />
                        </a>

                        <a
                            href="https://www.instagram.com/sujaramahaenterprises"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Sujaramaha Enterprises Instagram"
                        >
                            <FaInstagram aria-hidden="true" />
                        </a>

                        <a
                            href="https://www.facebook.com/share/16mturVQZw/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Sujaramaha Enterprises Facebook"
                        >
                            <FaFacebookF aria-hidden="true" />
                        </a>

                        <a
                            href="https://www.youtube.com/@SUJARAMAHAENTERPRISE"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Sujaramaha Enterprises YouTube"
                        >
                            <FaYoutube aria-hidden="true" />
                        </a>
                    </div>
                </div>

                {/* NAVIGATION */}
                <nav className="footer-col-navigation" aria-label="Footer navigation">
                    <h3>NAVIGATION</h3>
                    <ul>
                        <li><NavLink to="/" onClick={() => handleNavClick("/")}>Home</NavLink></li>
                        <li><NavLink to="/about" onClick={() => handleNavClick("/about")}>About Us</NavLink></li>
                        <li><NavLink to="/services" onClick={() => handleNavClick("/services")}>Services</NavLink></li>
                        <li><NavLink to="/careers" onClick={() => handleNavClick("/careers")}>Careers</NavLink></li>
                        <li><NavLink to="/careers" onClick={() => handleNavClick("/careers")}>News & Events</NavLink></li>
                    </ul>
                </nav>

                {/* SERVICES */}
                <section className="footer-col-services" aria-labelledby="footer-services">
                    <h3 id="footer-services">WHAT WE DO</h3>
                    <ul>
                        <li>Computer Sales & Services</li>
                        <li>Printer Sales & Services</li>
                        <li>CCTV Sales & Services</li>
                        <li>Solar Water Heater Sales & Services</li>
                        <li>Inverter & Battery Sales</li>
                        <li>All Types of Insurances</li>
                        <li>Water Filter / RO System</li>
                        <li>Kitchen Chimneys</li>
                    </ul>
                </section>

                {/* LEGAL */}
                <section className="footer-col-legal" aria-labelledby="footer-legal">
                    <h3 id="footer-legal">LEGAL</h3>
                    <ul>
                        <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                        <li><NavLink to="/terms">Terms of Use</NavLink></li>
                        <li><NavLink to="/security">Vulnerability Disclosure</NavLink></li>
                    </ul>
                </section>
            </div>

            {/* COPYRIGHT */}
            <div className="footer-bottom">
                © 2026 Sujaramaha Enterprises. All Rights Reserved.
            </div>
        </footer>
    );
}
